import { useQuery } from '@apollo/client';
import React, { useEffect, useState } from 'react';
import { Card, FlexCrate, Link, Text } from '@perch-labs/shrike';
import { copyFor } from 'config';
import { GET_STATEMENT_CSV } from './csv-download.api';

const getCopy = copyFor('billing.statement.csvDownload');

type CsvDownloadProps = {
  statementId: number;
};

export const CsvDownloadLink = ({
  statementId,
}: CsvDownloadProps): JSX.Element => {
  const [blobUrl, setBlobUrl] = useState<string | null>(null);
  const { data } = useQuery(GET_STATEMENT_CSV, {
    variables: { statementId },
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (data) {
      const blob = new Blob([data.statement.csv], { type: 'text/csv' });
      const url = URL.createObjectURL(blob);
      setBlobUrl(url);
    }

    // cleanup on unmount
    return () => {
      if (blobUrl) URL.revokeObjectURL(blobUrl);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return (
    <FlexCrate padding="24px 24px 0 24px" flexDirection="column" gap="16px">
      <Text textStyle="paragraph400">{getCopy('summary')}</Text>
      {blobUrl ? (
        <Link href={blobUrl} download="statement.csv" type="CTA">
          {getCopy('button')}
        </Link>
      ) : null}
    </FlexCrate>
  );
};

export const CsvDownloadCard = (props: CsvDownloadProps): JSX.Element => {
  return (
    <Card mobileVariant="flat" margin="16px 0">
      <Card.Content>
        <CsvDownloadLink {...props} />
      </Card.Content>
    </Card>
  );
};
